<template>
    <div id="divError">
        <div class="header-nav">
            <ul class="menu">
                <li><span></span></li>
            </ul>
        </div>

        <div id="divContent" class="main-content-row">
            <div class="col-lg-12 col-md-12">
                <p>{{ $t("message.errorMessage") }}</p>
            </div>

            <div class="col-lg-12 col-md-12">
                <button id="btnErrorBackToHome" class="btn btn-primary" @click.prevent="goToHomepage()">{{ $t("message.backToHome") }}</button>
            </div>
        </div>        
    </div>   
</template>

<script>
export default {
    name: 'Error',
    methods: {
        goToHomepage() {
            var routerPath = '/login';
            var navLinks = this.$store.getters.getNavigationMenuLinks;
            if (navLinks.length > 0) {
                routerPath = navLinks[0].PageLink;
            }

            // If CSR is logged in and viewing Customer Portal - they should be redirected to CSR Edit Home page
            // If Customer is logged in - they will be forwarded to either login page or the first link in our navigation object.
            if (this.$store.getters.getIsCSR) {
                window.location = this.$formatOldCustomerPortalLinks(this.$httpAxiosBaseUrl(), this.$PageLink.CsrEditHome);
            } else {
                this.$router.push({ path: routerPath });
            }            
            return;
        }
    }
}
</script>

<style scoped>
#divError #divContent {
    text-align: center;
}
</style>